import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import GuardiaRuolo, { ArrivoDelRuolo } from "@/components/auth/GuardiaRuolo";
import AppLayout from "@/components/layout/AppLayout";
import LoginPage from "@/pages/LoginPage";
import BenvenutoPage from "@/pages/BenvenutoPage";
import TotpEnrollmentPage from "@/pages/TotpEnrollmentPage";
import TotpChallengePage from "@/pages/TotpChallengePage";
import CruscottoPage from "@/pages/CruscottoPage";
import OggiPage from "@/pages/OggiPage";
import ClientiPage from "@/pages/ClientiPage";
import ClienteSchedaPage from "@/pages/ClienteSchedaPage";
import AssistenzaPage from "@/pages/AssistenzaPage";
import CalcolatorePage from "@/pages/CalcolatorePage";
import PreventivatoreListPage from "@/pages/PreventivatoreListPage";
import PreventivatoreEditorPage from "@/pages/PreventivatoreEditorPage";
import GuidePage, { AiutoPage } from "@/pages/GuidePage";
import ListiniPage from "@/pages/ListiniPage";
import ConsensoClaudePage from "@/pages/ConsensoClaudePage";
import ContrattiPage from "@/pages/ContrattiPage";
import FattureIncassiPage from "@/pages/FattureIncassiPage";
import MessaggiPage from "@/pages/MessaggiPage";
import CalendarioPage from "@/pages/CalendarioPage";
import ImpostazioniPage from "@/pages/ImpostazioniPage";
import SicurezzaPage from "@/pages/SicurezzaPage";
import DesignReferencePage, { DesignShell } from "@/pages/DesignReferencePage";

// Pagina di riferimento del sistema visivo. Non ha login e non fa rete: sono
// dati finti e componenti veri. Proprio per questo NON deve essere raggiungibile
// fuori dallo sviluppo — con l'interruttore spento la rotta non esiste nemmeno
// nell'albero, e /design finisce nel catch-all come un indirizzo inventato.
//
// Si accende con REACT_APP_DESIGN_ROUTE=1 in frontend/.env.development.local.
// ⚠️ In .env.development.local e NON in .env.local: react-scripts carica
// `.env.<NODE_ENV>.local` solo per quel NODE_ENV, mentre `.env.local` lo legge
// ANCHE `npm run build`. Messa li', la rotta finirebbe dentro un pacchetto di
// produzione costruito su questa macchina. Verificato servendo la build.
const DESIGN_ROUTE_ATTIVA = process.env.REACT_APP_DESIGN_ROUTE === "1";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster richColors position="top-right" />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/auth/benvenuto" element={<BenvenutoPage />} />
          <Route path="/auth/totp-enrollment" element={<TotpEnrollmentPage />} />
          <Route path="/auth/totp-verify" element={<TotpChallengePage />} />
          <Route path="/aiuto/:id" element={<AiutoPage />} />
          {/* Claude collegato (c37): fuori dal menu, con la sessione e il codice di sicurezza dietro. */}
          <Route
            path="/oauth/consenso"
            element={
              <ProtectedRoute>
                <ConsensoClaudePage />
              </ProtectedRoute>
            }
          />

          {DESIGN_ROUTE_ATTIVA ? (
            <Route path="/design" element={<DesignShell />}>
              <Route index element={<DesignReferencePage />} />
            </Route>
          ) : null}

          <Route
            element={
              <ProtectedRoute>
                {/* Chi vede cosa: la mappa è in lib/accessi.js. */}
                <GuardiaRuolo>
                  <AppLayout />
                </GuardiaRuolo>
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<ArrivoDelRuolo />} />
            <Route path="/cruscotto" element={<CruscottoPage />} />
            <Route path="/oggi" element={<OggiPage />} />
            <Route path="/clienti" element={<ClientiPage />} />
            <Route path="/clienti/:id" element={<ClienteSchedaPage />} />
            <Route path="/assistenza" element={<AssistenzaPage />} />
            <Route path="/preventivi" element={<PreventivatoreListPage />} />
            <Route path="/preventivi/calcolatore" element={<CalcolatorePage />} />
            <Route path="/preventivi/preventivatore" element={<Navigate to="/preventivi" replace />} />
            <Route path="/preventivi/preventivatore/:id" element={<PreventivatoreEditorPage />} />
            <Route path="/listini" element={<ListiniPage />} />
            <Route path="/contratti" element={<ContrattiPage />} />
            <Route path="/fatture-incassi" element={<FattureIncassiPage />} />
            <Route path="/calendario" element={<CalendarioPage />} />
            <Route path="/messaggi" element={<MessaggiPage />} />
            <Route path="/impostazioni" element={<ImpostazioniPage />} />
            <Route path="/sicurezza" element={<SicurezzaPage />} />
            <Route path="/guide" element={<GuidePage />} />
            <Route path="/guide/:id" element={<GuidePage />} />
          </Route>

          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
